import ssc from './ssc';
import ks from './ks';
import choose5 from './choose5';
import hpten from './hpten';

export default (type) => {
  if (type == 'ssc') {
    return ssc();
  }
  if (type == 'choose5') {
    return choose5();
  }
  if (type == 'hpten') {
    return hpten();
  }
  if (type == 'ks') {
    return ks();
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Meirichanglongtongji/columns/index.js